import { render } from "./Home.vue?vue&type=template&id=faca5e96&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=faca5e96&lang=css"
import "./Home.vue?vue&type=style&index=1&id=faca5e96&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faca5e96"]])

export default __exports__